// Single source of truth for PFG (Warranty) scan status badge colors. Mirrors
// the scan_status enum in Warranty.
//
// Confirmed with the production team: a new scan is the good outcome.
//
// green - a scan was taken since the last retainer shipment, so it is fresh and
//         the replacement can be made from it as-is
// red   - no scan since the last shipment, so the one on file may be stale and a
//         new one is likely needed before the retainer can be remade
const WARRANTY_SCAN_STATUS_COLORS = {
  no_new_scan: 'red',
  new_scan: 'green',
};

// Accepts either the raw enum value ("no_new_scan") or the humanized form the
// AG Grid value getter produces ("No New Scan"). Returns null for anything that
// is not a warranty scan status so callers can fall back to their own default.
function warrantyScanStatusColor(scanStatus) {
  if (!scanStatus) {
    return null;
  }

  const key = String(scanStatus).toLowerCase().replace(/\s+/g, '_');

  return WARRANTY_SCAN_STATUS_COLORS[key] || null;
}

export default warrantyScanStatusColor;
